import axios from 'axios'
const TypesModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    FETCH: (state, payload) => {
      state.data = payload
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`portal/types`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    }
  }
}

export default TypesModule
